<template>
  <div class="initiativet">
    <h1 style="font-weight:700;">教師能如何提倡開放取用</h1>
    <h3 style="font-weight:500;">當您的研究領域中有合適的開放取用期刊時，將您的研究論文投稿至開放取用期刊。</h3>
    <br>
    <h3 style="font-weight:500;">將您的預刊本存放在開放取用、符合OAI-PMH規範的典藏庫。</h3>
    <ul class="txt1" style="text-indent : -1em ;">
      <li>
        ● 這可以是學科領域的典藏庫或是機構典藏。
      </li>
      <p style="line-height:2;"></p>
      <li>● 範例：</li>
      <p style="text-indent : 2em ; line-height:1;">國立臺灣師範大學圖書館的機構典藏庫網址為：http://rportal.lib.ntnu.edu.tw/。
      </p>
      <p style="text-indent : 2em ; line-height:1;">您可以聯繫吳小姐（電話 (02) 7734-5270｜E-mail:libread@ntnu.edu.tw），圖書館將竭誠為您服務。</p>
      <p style="line-height:2;"></p>
    </ul>
    <br>
    <h3 style="font-weight:500;">將您的作者定稿本儲存在開放取用典藏庫。</h3>
    <ul class="txt1" style="text-indent : -1em ;">
      <li>
        ● 所謂作者定稿本是指經由同儕審查後獲期刊接受的作者原稿，經常是已經過修訂的。
      </li>
      <p style="line-height:2;"></p>
      <li>
        ● 若是您將著作權轉移給出版社，那麼典藏作者定稿本就需要徵得期刊方的同意。然而，近八成的期刊都已經預先同意作者能夠自行典藏作者定稿本了，部分期刊遇到這樣的徵詢時也都會答應。也有部分可能會拒絕。有關出版社對於著作權及作者自行典藏方面的政策，請參考下述由SHERPA計畫維護的資料庫，使用者可於資料庫中進行搜尋。
        <br><a href="http://romeo.eprints.org/stats.php">http://romeo.eprints.org/stats.php</a>
        <br><a href="http://www.sherpa.ac.uk/romeo/index.html">http://www.sherpa.ac.uk/romeo/index.html</a>
        <br><a href="http://sherpa.ac.uk">http://sherpa.ac.uk</a>
      </li>
      <p style="line-height:2;"></p>
      <li>
        ● 若是您尚未將著作權轉移給出版社，那麼請您保留您的著作權。相關網址：<a href="http://www.earlham.edu/~peters/fos/do.htm#retaincopyright">http://www.earlham.edu/~peters/fos/do.htm#retaincopyright</a>
      </li>
      <p style="line-height:2;"></p>
      <li>● 若是期刊方不願意讓您保留著作權，那麼請期刊至少讓您保留典藏作者定稿本權利。</li>
      <li style="text-indent : 0em ;">☞ 若是期刊方不讓您保留典藏作者定稿本的權利，那麼請他們同意讓您將作者定稿本上傳在您個人的網站上。對許多期刊來說，透過典藏庫和透過個人網站的開放取用，兩者間有顯著的差別。</li>
      <p style="line-height:2;"></p>
      <li>● 若是您已經轉移著作權給出版社，而對方不同意您典藏作者定稿本，那麼請至少在開放取用的典藏庫中上傳期刊論文的詮釋資料（也就是引用所需的資料，如作者、篇名、期刊、日期等等）。如此一來能夠讓其他研究者在進行搜尋時，知道有這篇期刊文章的存在，之後便可以透過電子郵件向您取得期刊文章。</li>
      <li style="text-indent : 0em ;">☞ 在大部分的情況下，你可以上傳全文至典藏庫，並勾選「限機構內取用」的選項，而非「開放取用」。如此一來，至少您的機構同事和學生可以立即取得您的文章。此外，若是出版社同意在文章出版一段期間後（例如六個月）後可以開放取用，這種情形雖令人不滿意但也還可以接受，畢竟只要時限一到即可順利達成開放取用了。</li>
      <p style="line-height:2;"></p>
    </ul>
    <br>
    <h3 style="font-weight:500;">將您的研究資料與依據這些研究資料所撰寫而出的期刊論文一併存放在開放取用典藏庫裡。若是可能的話，將這些研究資料連結到文章之中，反之亦然，如此一來，讀者便會知道該從哪裡找到期刊論文或研究資料。</h3>
    <br>
    <h3 style="font-weight:500;">當受邀擔任開放期刊的審查者或者編輯群時，請欣然接受邀請（請注意篩選掠奪性期刊）。</h3>
    <ul class="txt1" style="text-indent : -1em ;">
      <li>
        ● 教師不需要投注他們的時間和精神在那些將他們的內容鎖在付費牆（Paywall)之後的期刊，因為這樣對於專業學術的貢獻有限。大學應該要支持做出這個有潛在職涯風險決定的教師。教師不需要抵制需付費的期刊，但同時也不需要去支持它們。
      </li>
      <p style="line-height:2;"></p>
    </ul>
    <br>
    <h3 style="font-weight:500; text-align:left;">若是您是傳統收費形式期刊的編輯群成員，那麼開始一個內部的討論，討論將期刊轉型成開放取用的期刊，或者是試驗型的開放取用，讓作者保留著作權，廢除英葛芬格規則(參見<a href="https://en.wikipedia.org/wiki/Ingelfinger_rule">維基百科</a>)，或者是宣告獨立（結束原有期刊並成立新的開放取用期刊，繼續服務相同研究領域的學者）。相關網址：<a href="http://www.earlham.edu/~peters/fos/lists.htm#declarations">http://www.earlham.edu/~peters/fos/lists.htm#declarations</a></h3>
    <ul class="txt1" style="text-indent : -1em ;">
      <li>● 更多關於期刊能做的事，請參考下列清單
        <a href="http://www.earlham.edu./~peters/fos/do.htm#journals">http://www.earlham.edu./~peters/fos/do.htm#journals</a>
      </li>
    </ul>
    <br>
    <h3 style="font-weight:500;">參與您大學的各級教評會對教師進行的評鑑與升等，確保委員會們所使用的標準中，至少不要懲罰將期刊文章投稿至經同儕審查的開放取用期刊的教師。最好是能夠調整評鑑的標準，提供一些誘因，讓教師將他們的研究文章、預刊本等，透過開放取用期刊或典藏庫的方式，提供給大眾。</h3>
    <ul class="txt1" style="text-indent : -1em ;">
      <li>● 看更多其他有經驗的學會如何支持開放取用，請見下方連結：
        <a href="http://www.earlham.edu/~peters/fos/newsletter/11-02-07.htm#list">http://www.earlham.edu/~peters/fos/newsletter/11-02-07.htm#list</a>
      </li>
    </ul>
    <br>
    <h3 style="font-weight:500;">和您的專業學會一起合作，確保他們了解開放取用。試著說服機構建立他們自己的開放取用期刊，在領域中支持其他期刊的開放取用，並且支持領域中所有的學者進行電子版文章的開放取用。相關網址：<a href="http://www.earlham.edu./~peters/fos/overview.htm">http://www.earlham.edu./~peters/fos/overview.htm</a></h3>
    <ul class="txt1" style="text-indent : -1em ;">
      <li>● 若是學會為專業領域成立了電子版文章的典藏庫，請考慮讓建置在您的大學（圖書館），就像arXiv是在康乃爾大學之下一樣。<a href="http://arxiv.org/">http://arxiv.org/</a></li>
      <li>● 同樣從清單中看更多其他有經驗的學會能做的事，藉由這些經驗說服您的學會考慮這些行動。請其他成員協助您改變這些學會裡的取用政策。相關網址：<a href="http://www.earlham.edu/~peters/fos/do.htm#societies">http://www.earlham.edu/~peters/fos/do.htm#societies</a></li>
    </ul>
    <br>
    <h3 style="font-weight:500;">撰寫評論意見（文章、主編的話、報紙社論、致信給編輯、論壇討論、民意論壇等）加以宣傳開放取用。</h3>
    <h3 style="font-weight:500;">教育下一代年輕的科學家和學者有關開放取用的觀念。</h3>
    <h3 style="font-weight:500;">資料來源：<a href="https://st3.ning.com/topology/rest/1.0/file/get/2865287841?profile=original">https://st3.ning.com/topology/rest/1.0/file/get/2865287841?profile=original</a></h3>
  </div>
</template>
<script>
export default {
  name: 'Initiativet',
  data() {

  }
}

</script>
<style>
/*@font-face {
  font-family: Times New Roman;
  src: url(DroidSans.woff);
  unicode-range: U+000-5FF, U+1e00-1fff, U+2000-2300;
}*/


.initiativet {
  padding: 4%;
  padding-top: 2%;
  background-color: rgba(248, 194, 88,0.1);
  box-shadow: 0 5px 5px -2px rgba(0, 0, 0, .2);
  padding-bottom: 50px;

}



.txt {


  font-size: 20px;
  text-align: left;
  text-indent: 2em;
  font-weight: 500;

}

.txt1 {

  line-height: 1.5;
  font-size: 20px;
  text-align: left;
  padding-left: 12px;
  font-weight: 500;

}

</style>
